import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";

export const useReportedMaximumAnnualSales = () => {
  const { retailer } = useRetailer();

  const reportedMaximumAnnualSales = retailer?.annual_sales_max_amount;

  return { reportedMaximumAnnualSales };
};
